// extracted by mini-css-extract-plugin
export default {"root":"forehead_root__aVT7g","loading":"forehead_loading__lRB6d","statistics":"forehead_statistics__B7CRT","items":"forehead_items__msazD"};